import React, { useState, useEffect } from "react";
import { Octokit } from "@octokit/rest";

const UploadImage = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageList, setImageList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const octokit = new Octokit({
    auth: process.env.REACT_APP_GHTOKEN,
  });

  const repositories = [
    { owner: "kirmago", repo: "github-kirmago-w" },
    { owner: "kirmago", repo: "github-kirmago-alt1" },
    { owner: "kirmago", repo: "github-kirmago-alt2" },
  ];

  useEffect(() => {
    // Ambil gambar dari local storage saat komponen dimuat
    const storedImages = JSON.parse(localStorage.getItem("githubImages")) || [];
    setImageList(storedImages);
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUploadToRepository = async (repository, base64File, fileName) => {
    const url = `images/${fileName}`;
    try {
      await octokit.repos.createOrUpdateFileContents({
        owner: repository.owner,
        repo: repository.repo,
        path: url,
        message: "Upload image",
        content: base64File,
      });

      const newImageUrl = `https://raw.githubusercontent.com/${repository.owner}/${repository.repo}/main/images/${fileName}`;
      return newImageUrl;
    } catch (error) {
      if (error.status === 403) {
        return null;
      } else {
        throw error;
      }
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    setErrorMessage("");

    const fileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      const base64File = reader.result.split(",")[1];

      let uploadedUrl = null;
      for (let i = 0; i < repositories.length; i++) {
        try {
          uploadedUrl = await handleUploadToRepository(
            repositories[i],
            base64File,
            fileName
          );
          if (uploadedUrl) break;
        } catch (error) {
          console.error(
            `Error uploading to repository ${repositories[i].repo}:`,
            error
          );
          setErrorMessage("An unexpected error occurred during upload.");
        }
      }

      if (uploadedUrl) {
        setImageUrl(uploadedUrl);

        const updatedImageList = [
          ...imageList,
          { url: uploadedUrl, name: fileName },
        ];
        localStorage.setItem("githubImages", JSON.stringify(updatedImageList));
        setImageList(updatedImageList);
      } else {
        setErrorMessage(
          "All repositories are full. Could not upload the image."
        );
      }

      setUploading(false);
    };
  };

  const handleDelete = async (urlToDelete) => {
    setDeleting(urlToDelete);
    setErrorMessage("");
    const fileName = urlToDelete.split("/").pop();
    const path = `images/${fileName}`;

    let deleted = false;

    for (let i = 0; i < repositories.length; i++) {
      try {
        // Dapatkan SHA file yang akan dihapus
        const { data: fileData } = await octokit.repos.getContent({
          owner: repositories[i].owner,
          repo: repositories[i].repo,
          path,
        });

        await octokit.repos.deleteFile({
          owner: repositories[i].owner,
          repo: repositories[i].repo,
          path,
          message: "Delete image",
          sha: fileData.sha,
        });

        // Verifikasi bahwa file telah dihapus
        try {
          await octokit.repos.getContent({
            owner: repositories[i].owner,
            repo: repositories[i].repo,
            path,
          });
        } catch (verificationError) {
          if (verificationError.status === 404) {
            // Hapus gambar dari local storage
            const updatedImageList = imageList.filter(
              (image) => image.url !== urlToDelete
            );
            localStorage.setItem(
              "githubImages",
              JSON.stringify(updatedImageList)
            );
            setImageList(updatedImageList);
            deleted = true;
          } else {
            console.error("Error verifying image deletion:", verificationError);
          }
        }

        if (deleted) break;
      } catch (error) {
        if (error.status === 403) {
          setErrorMessage("Repository storage limit reached.");
        } else if (error.status === 404) {
          // Hapus gambar dari local storage jika file tidak ditemukan di GitHub
          const updatedImageList = imageList.filter(
            (image) => image.url !== urlToDelete
          );
          localStorage.setItem(
            "githubImages",
            JSON.stringify(updatedImageList)
          );
          setImageList(updatedImageList);
          deleted = true;
          break;
        } else {
          console.error("Error deleting image:", error);
        }
      }
    }

    setDeleting("");
  };

  return (
    <div>
      <input
        required
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload Image"}
      </button>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      {imageUrl && (
        <div>
          <p>Image URL:</p>
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            {imageUrl}
          </a>
          <img src={imageUrl} alt="Uploaded" style={{ width: "200px" }} />
        </div>
      )}
      <div>
        <h2>Uploaded Images</h2>
        {imageList.map((image, index) => (
          <div key={index}>
            <p>{image.name}</p>
            <img
              src={image.url}
              alt={`Uploaded ${index}`}
              style={{ width: "500px" }}
            />
            <button
              onClick={() => handleDelete(image.url)}
              disabled={deleting === image.url}
            >
              {deleting === image.url ? "Deleting..." : "Delete"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadImage;
